"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var react_ace_1 = require("react-ace");
var AffilateBannerTPLEditor = /** @class */ (function (_super) {
    __extends(AffilateBannerTPLEditor, _super);
    function AffilateBannerTPLEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilateBannerTPLEditor.prototype.componentWillMount = function () {
        this.setState({
            textRaw: UIUtils_1.UIUtils.Base64DecodeU(this.props.textBase64),
            is_fullscreen: false
        });
        this.props.state.setExtBreadCrumbPath([
            "Список П.Программ",
            "\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0448\u0430\u0431\u043B\u043E\u043D\u0430 \u0431\u0430\u043D\u043D\u0435\u0440\u0430: [" + this.props.record.title + "]"
        ]);
    };
    AffilateBannerTPLEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.SetBannerTemplate(this.props.record.key, UIUtils_1.UIUtils.Base64EncodeU(this.state.textRaw), function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Запись изменена!");
            });
        }
        else {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Шаблон не может быть пуcтым!");
        }
    };
    AffilateBannerTPLEditor.prototype.isDataValid = function () {
        if (!this.state.textRaw) {
            return false;
        }
        if (this.state.textRaw.length === 0) {
            return false;
        }
        return true;
    };
    AffilateBannerTPLEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilateBannerTPLEditor.prototype.OnMaxButtonClick = function (isMax) {
        this.setState({ is_fullscreen: isMax });
    };
    AffilateBannerTPLEditor.prototype.getFormTitle = function () {
        return "Изменить шаблон баннера";
    };
    AffilateBannerTPLEditor.prototype.onChange = function (newValue) {
        this.setState({ textRaw: newValue });
    };
    AffilateBannerTPLEditor.prototype.getEditorHeight = function () {
        if (this.state.is_fullscreen) {
            return "calc( 100vh - 270px )";
        }
        else {
            return "450px";
        }
    };
    AffilateBannerTPLEditor.prototype.render = function () {
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), onMaxButtonClick: this.OnMaxButtonClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 600, showMaxButton: true },
            React.createElement("div", { style: {
                    minHeight: "500px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start"
                } },
                React.createElement(react_ace_1.default, { mode: "ftl", theme: "sqlserver", onChange: this.onChange.bind(this), name: "UNIQUE_ID_OF_RECORD_AFF_BANNER_TEMPLATE_DIV", editorProps: { $blockScrolling: true }, width: "100%", height: this.getEditorHeight(), fontSize: 14, value: this.state.textRaw, style: { borderStyle: "solid", borderWidth: "1px", borderColor: "#d9d9d9" } }),
                React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }))));
    };
    return AffilateBannerTPLEditor;
}(React.Component));
exports.default = AffilateBannerTPLEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/AffilateBannerTPLEditor.tsx
// module id = 2013
// module chunks = 0